import React, { useState } from "react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { act } from "../../lib/useFetch";
import { Field } from "./AdminDialog";

export default function PasswordForm() {
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const save = async (e) => {
    e.preventDefault();
    if (form.new_password !== form.confirm) { toast.error("Новые пароли не совпадают"); return; }
    const res = await act(api.post("/auth/change-password", { current_password: form.current_password, new_password: form.new_password }),
      "Пароль изменён. Остальные сессии завершены");
    if (res) setForm({ current_password: "", new_password: "", confirm: "" });
  };

  return (
    <form onSubmit={save} className="grid sm:grid-cols-3 gap-3 items-end" data-testid="password-form">
      <Field label="Текущий пароль"><input required type="password" value={form.current_password} onChange={set("current_password")} data-testid="password-current-input" /></Field>
      <Field label="Новый пароль (от 8 символов)"><input required minLength={8} type="password" value={form.new_password} onChange={set("new_password")} data-testid="password-new-input" /></Field>
      <Field label="Повторите новый"><input required minLength={8} type="password" value={form.confirm} onChange={set("confirm")} data-testid="password-confirm-input" /></Field>
      <button type="submit" className="btn-gold sm:col-span-3 justify-self-start" data-testid="password-save-btn">Сменить пароль</button>
    </form>
  );
}
